import { Environment } from "react-relay";
import EventsSectionPage, {
  loader as sectionLoader,
} from "./_activity._section";

export default function UpcomingEventsSectionPage() {
  return <EventsSectionPage sectionKind="upcoming" />;
}

export const loader = (environment: Environment) =>
  sectionLoader(environment, "active");
